/**
 * Freigabeweg (Board „Preisautomatik · Einstellungen“): rechts als Liste, im schmalen Container als
 * Streifen mit vier Schritten oben (Board „Einstellungen · Handy“). Die Schritte rechnet
 * `releaseRailModel`.
 */
import { cn } from '@/shared/lib/cn';
import type { ReleaseStep } from './releaseRailModel';

export function ConfigurationReleaseRail({
  steps,
  publicationControlsAvailable,
}: {
  steps: ReleaseStep[];
  publicationControlsAvailable: boolean;
}) {
  return (
    <aside
      aria-label="Freigabeweg"
      className="bg-card rounded-tile shadow-float @5xl:sticky @5xl:top-4 @5xl:order-none @5xl:p-[18px] order-first flex min-w-0 flex-col gap-1 px-3.5 py-3"
    >
      <span className="text-ink-soft @5xl:not-sr-only sr-only font-mono text-[10px] font-semibold uppercase tracking-[0.16em]">
        Freigabeweg
      </span>
      <ol className="@5xl:flex @5xl:flex-col grid grid-cols-4 gap-1">
        {steps.map((step, index) => (
          <li
            key={step.label}
            className="@5xl:flex-row @5xl:items-start @5xl:gap-3 @5xl:py-2.5 @5xl:text-left flex flex-col items-center gap-1 text-center"
          >
            <span
              aria-hidden
              className={cn(
                'grid size-7 flex-none place-items-center rounded-full text-[13px] font-extrabold',
                step.state === 'done' && 'bg-forest text-white',
                step.state === 'now' && 'bg-amber-on-dark text-ink',
                step.state === 'todo' && 'border-line text-ink-faint border-[1.5px]',
              )}
            >
              {step.state === 'done' ? '✓' : index + 1}
            </span>
            <span className="@5xl:items-start flex min-w-0 flex-col items-center gap-0.5">
              <span className="@5xl:text-sm text-[11px] font-bold leading-tight">
                {step.label}
                <span className="sr-only">
                  {step.state === 'done' ? ' (erledigt)' : step.state === 'now' ? ' (jetzt)' : ''}
                </span>
              </span>
              <span className="text-ink-soft @5xl:text-xs text-[10px] leading-[1.3]">
                {step.detail}
              </span>
            </span>
          </li>
        ))}
      </ol>
      {!publicationControlsAvailable && (
        <span className="bg-amber-tint text-amber-ink rounded-control mt-2 px-3 py-2 text-xs font-bold">
          Ohne Publikationssteuerung lässt sich nur „Aus“ speichern.
        </span>
      )}
    </aside>
  );
}
